import React, {useContext} from 'react';
import { CalendarChangeRequestContext } from '../context/CalendarChangeRequestProvider';
import ProcessingSpinner from '../../components/UI/Spinner/ProcessingSpinner';
import Model from '../../components/UI/Modal/Model';
import IdleTimerContainer from '../../containers/IdleTimer/IdleTimerContainer';
import { ChangeRequestProvider } from '../context/ChangeRequestProvider';
import ChangeRequestOverviewContainer from '../container/ChangeRequestOverviewContainer';
import { RequestStatus } from '../../common/const/RequestStatus';

function ChangeRequestContainer(props) {

    const { idleTimeoutLimit, sessionTimeoutLimit, isLoading, showModel, remarksOptions,
            errorMessage, isError, modelHeaderTitle, showInstructions, resetSubmittedAndErrorFlags,
            handleConfirmationYesClick ,isSuccessfullySaved} = useContext(CalendarChangeRequestContext);  
 
    return (
        <>
            <div className="sidebar-bottomcontent-container-col">
                <div style={{height:"49.8vh"}}><></></div>    
            </div>
            <div className="sidebar-bottomcontent-container-next-col">
                    <div className="main-contents">
                        <div className="main-content"> 
                            <div className="nmbs-main">
                                {remarksOptions && <ChangeRequestProvider 
                                    BusinessPartnerCode={props.BusinessPartnerCode}
                                    isLogout={props.isLogout}
                                    onLogoutClick={props.onLogoutClick}
                                    clearSessionData={props.clearSessionData}
                                    UserId={props.UserId}
                                    isNmbsUser={props.isNmbsUser}>
                                    <ChangeRequestOverviewContainer
                                        BusinessPartnerCode={props.BusinessPartnerCode}
                                        isNmbsUser={props.isNmbsUser}
                                        isEditAccess={props.isEditAccess}
                                        isLogout={props.isLogout}
                                        onLogoutClick={props.onLogoutClick}
                                        clearSessionData={props.clearSessionData}
                                    />
                                </ChangeRequestProvider>}
                            </div>
                        </div>
                    </div>
            </div> 
            {   
                <Model showModel={showModel}
                    onHideHandler={resetSubmittedAndErrorFlags}
                    showHeader={showModel}
                    headerTitle={modelHeaderTitle}
                    showError={isError}
                    errorMessage={errorMessage}
                    isMonthlyIntakeBook={true}
                    isBusinessPartner={true}
                    showInstructions={showInstructions}
                    handleConfirmationYesClick={handleConfirmationYesClick}
                    showSuccess={isSuccessfullySaved} 
                    successMessage= {"cr_submitted_successfully"}
                />
            }           
            {
                    isLoading ? 
                    <ProcessingSpinner Status={RequestStatus.Inprogress.id}
                        BusinessPartnerCode={props.BusinessPartnerCode}
                    />
                        : undefined
                }
            {sessionTimeoutLimit && idleTimeoutLimit && <IdleTimerContainer idleTimeoutLimit={1000 * idleTimeoutLimit}
                                    sessionTimeoutLimit={1000 * sessionTimeoutLimit}
                                    logout={props.onLogoutClick} />}
        </>
    );
}

export default ChangeRequestContainer;